import { SelectDataDictionary } from './SelectDataDictionary';
import { hasPermissionToRender } from '@/app/core/utils';
import { useSetPageTitle } from '@/app/store';
import { Tabs } from '@ssar-app/uikit';
import { Flex, Text, HStack, Divider } from '@chakra-ui/react';
import { AppRoles, FeatureCodes } from '@ssar-app/domain';

export const AdminPage = () => {
  useSetPageTitle('Quest Admin');
  const mayViewDataDictionaries = hasPermissionToRender(
    FeatureCodes.AscendQuest,
    AppRoles.AscendQuest.Admin.permissions.MayViewAppDataDictionaries,
  );
  const tabItems = [
    {
      label: 'Data Dictionary',
      key: 'dataDictionary',
      content: <SelectDataDictionary />,
      isDisabled: !mayViewDataDictionaries,
    },
  ];

  return (
    <>
      <HStack justify='space-between'>
        <Text fontSize='2xl' fontWeight='semibold' mb={2} color={'black'}>
          Quest Admin
        </Text>
      </HStack>
      <Divider mb={4} color='gray.400' />
      <Flex
        direction={'column'}
        bg='#fff'
        // p={'15px'}
        boxShadow='0 3px 10px rgb(0 0 0 / 10%)'
      >
        <Tabs
          variant='line'
          items={tabItems}
          tabListProps={{ borderColor: 'gray.500' }}
          tabLabelProps={{ fontSize: 'md' }}
          tabProps={{ h: 10 }}
        />
      </Flex>
    </>
  );
};
